<div class="p-6 pt-4">
    <h3 class="text-xl mb-2">{{ 'seasons.season-creation.dialogs.cancel-dialog.title' | translate }}</h3>
    <p class="text-base">{{ 'seasons.season-creation.dialogs.cancel-dialog.text' | translate }}</p>
    <div class="flex justify-end items-center gap-2 mt-8">
        <sh-button
            color="secondary"
            icon="arrow-line-left-s"
            iconPosition="left"
            layout="compact"
            (click)="onClose()"
            ariaLabel="reject"
            [label]="'seasons.season-creation.dialogs.cancel-dialog.reject' | translate"
        />
        <sh-button
            icon="cancel"
            iconPosition="left"
            layout="compact"
            (click)="onClose('cancel')"
            ariaLabel="Accept"
            [label]="'seasons.season-creation.dialogs.cancel-dialog.accept' | translate"
        />
    </div>
</div>
